import { List,Record } from "immutable";

import CheckboxStates from "../../../../constants/checkboxStates";
import createFromJS from "../../../createFromJS";

export const MenuItemRecord = Record({
  label: "",
  messageType: "",
  value: "",
  shortcut: "",
  disabled: false,
  children: List(),
  state: CheckboxStates.UNCHECKED,
  hasSeparator: false
});

const data = {
  collections: {
    children: "MenuItemRecord"
  }
};
createFromJS.registerCallback("MenuItemRecord", createFromJS.createNestedCallback(MenuItemRecord, data));
